import React from 'react';
import { useTranslation } from 'react-i18next';

interface IAccountMenuItemsProps {
	darkModeStatus: boolean;
	navigate: (path: string) => void;
	onSignOut: () => void;
}

/**
 * The logged-in account dropdown's items — shared between the desktop nav
 * (text link) and the compact mobile bar (icon button) so the two stay in
 * sync instead of drifting apart as separate copies.
 */
const AccountMenuItems: React.FC<IAccountMenuItemsProps> = ({ darkModeStatus, navigate, onSignOut }) => {
	const { t } = useTranslation();

	const rowBg = darkModeStatus ? 'rgba(var(--bs-info-rgb), 0.1)' : 'rgba(var(--bs-info-rgb), 0.08)';
	const rowBgHover = darkModeStatus ? 'rgba(var(--bs-info-rgb), 0.2)' : 'rgba(var(--bs-info-rgb), 0.15)';

	const items: { label: string; onClick: () => void }[] = [
		{ label: t('My Orders'), onClick: () => navigate('/my-orders') },
		{ label: t('My Avatars'), onClick: () => navigate('/my-avatars') },
		{ label: t('My Cart'), onClick: () => navigate('/my-cart') },
		{ label: t('Account Settings'), onClick: () => navigate('/account-settings') },
		{ label: t('Sign out'), onClick: onSignOut },
	];

	return (
		<div className='column col-12'>
			{items.map((item) => (
				<div
					key={item.label}
					onClick={item.onClick}
					className='col-12 p-3 transition-base cursor-pointer border-bottom'
					style={{ background: rowBg }}
					onMouseEnter={(e) => { e.currentTarget.style.background = rowBgHover; }}
					onMouseLeave={(e) => { e.currentTarget.style.background = rowBg; }}>
					<div className='d-flex flex-column align-items-center justify-content-center'>
						<span>{item.label}</span>
					</div>
				</div>
			))}
		</div>
	);
};

export default AccountMenuItems;
